import { Box, Divider, Typography } from '@mui/material'
import { InfoIcon } from '../Svgs'
import { formatNumber } from '../../utils/Common'
import TakeOffTooltip from './TakeOffTooltip'
import { Can } from '../../utils/AbilityUtil'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../../models/AccessControl'

const tooltipText = `All pricing displayed is for general informational purposes only and may not reflect final costs, as actual charges vary based on specific circumstances.`

const SelectedCostEstimation = () => {
  return (
    <Box
      sx={{
        gap: '8px',
        display: 'flex',
        paddingY: '16px',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '4px',
          alignItems: 'baseline',
        }}
      >
        <Typography
          sx={{
            color: '#06004A',

            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
          }}
        >
          Selected Cost Est.
        </Typography>

        <TakeOffTooltip title={tooltipText}>
          <InfoIcon sx={{ color: '#04002E', fontSize: 12 }} />
        </TakeOffTooltip>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          padding: '8px 16px',
          backgroundColor: '#3F69FF',
          borderRadius: '4px',
          gap: '24px',
        }}
      >
        <Can I={AttributeActionNames.Read} a={AttributeResourceNames.TakeOff}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              width: '50%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '4px',
                alignItems: 'baseline',
              }}
            >
              <Typography
                sx={{
                  color: 'white',

                  fontSize: '12px',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}
              >
                Total Selected
              </Typography>

              <TakeOffTooltip title={tooltipText}>
                <InfoIcon sx={{ color: 'white', fontSize: 10 }} />
              </TakeOffTooltip>
            </Box>

            <Typography
              sx={{
                color: 'white',

                fontSize: '28px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: 'normal',
              }}
            >
              ${formatNumber(121302)}
            </Typography>
          </Box>

          <Divider
            variant='fullWidth'
            orientation='vertical'
            flexItem
            sx={{ background: '#D6D6D6' }}
          />

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              width: '50%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: '4px',
                alignItems: 'baseline',
              }}
            >
              <Typography
                sx={{
                  color: 'white',

                  fontSize: '12px',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}
              >
                Selected Material Cost
              </Typography>

              <TakeOffTooltip title={tooltipText}>
                <InfoIcon sx={{ color: 'white', fontSize: 10 }} />
              </TakeOffTooltip>
            </Box>

            <Typography
              sx={{
                color: 'white',

                fontSize: '28px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: 'normal',
              }}
            >
              ${formatNumber(70000)}
            </Typography>
          </Box>
        </Can>
      </Box>
    </Box>
  )
}

export default SelectedCostEstimation
